import axios from "axios";

export const certificateApi = {
  templates: async () => {
    const res = await axios.get("/scholar-register/certificates/templates");
    return res.data as Array<{ id: string; name: string; code: string }>;
  },
  templateFields: async (templateId: string) => {
    const res = await axios.get(`/scholar-register/certificates/templates/${templateId}/fields`);
    return res.data as {
      templateId: string;
      requiredFields: Array<{ key: string; label: string; type: string; options?: string[] }>;
    };
  },
  students: async (params: { sessionId?: string; classId?: string; sectionId?: string; search?: string }) => {
    const res = await axios.get("/scholar-register/certificates/students", { params });
    return res.data as Array<{ id: string; admissionNumber: string; scholarNumber: string | null; firstName: string; lastName: string; class?: { name: string }; section?: { name: string } }>;
  },
  generate: async (payload: { studentId: string; templateId: string; issueDate: string; remarks?: string; preview?: string; extraFields?: Record<string, string> }) => {
    const res = await axios.post("/scholar-register/certificates/generate", payload);
    return res.data;
  },
  history: async (params: { studentId?: string; templateId?: string; fromDate?: string; toDate?: string; page?: number; limit?: number }) => {
    const res = await axios.get("/scholar-register/certificates/history", { params });
    return res.data as { items: any[]; total: number; page: number; limit: number };
  },
  pdf: async (id: string) => {
    const res = await axios.get(`/scholar-register/certificates/${id}/pdf`, { responseType: "blob" });
    return res;
  },
};
